<template>
  <div class="wap page">
    <div>
      <Head id="header" :extras="extras" :logo="defaultRess.wap.logo" />
      <Banner :extras="extras" id="banner" />
      <div class="container" id="container">
        <div class="item-content">
          <div
            class="item-title"
            v-if="extraItem.extras('listTitle.display') == '1'"
            :style="{
              color: extraItem.extras('listTitle.color'),
              fontSize: pxOrVw(extraItem.extras('listTitle.size')),
              fontWeight:
                extraItem.extras('listTitle.weight') == 'default'
                  ? '600'
                  : extraItem.extras('listTitle.weight')
            }"
          >
            {{ fileData.name }}
          </div>
          <div class="item-summary" v-if="fileData.descInfo">
            {{ fileData.descInfo }}
          </div>
          <div class="item-date" v-if="extraItem.extras('times.display') == '1'">
            {{ fileData.dateText }} <span class="icontemp chakan1"></span>
            {{ fileData.previewCount }} <span class="icontemp xiazai1"></span>{{ fileData.downloadCount }}
            <span class="icontemp wendang"></span>{{ fileData.sizeText }}
          </div>
          <div class="content-rich-text" v-if="fileData.previewType == '2'">
            <div class="rich-text-html" v-html="fileData.previewShow"></div>
          </div>
          <div class="item-button" id="item-button">
            <div
                    class="button"
                    :style="{
                color: extraItem.extras('themecolor.bgcolor'),
                borderColor: extraItem.extras('themecolor.bgcolor')
              }"
                    v-if="extraItem.extras('downloadBtnName.display') == 1"
                    @click="onDownloadFile(fileData, fileData.downloadType)"
            >
              {{ extraItem.extras("downloadBtnName.model") || "下载文档" }}
            </div>
            <div
              class="button"
              :style="{
                color: extraItem.extras('themecolor.bgcolor'),
                borderColor: extraItem.extras('themecolor.bgcolor')
              }"
              v-if="
                (fileData.previewType == '2' || noLogin) &&
                  !showPreview &&
                  extraItem.extras('previewBtnName.display') == 1
              "
              @click="onPreview(fileData, noLogin)"
            >
              {{ extraItem.extras("previewBtnName.model") || "预览全部内容" }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Back />
    <file-preview
      id="preview"
      @gettenantId="gettenantId"
      class="pxtovw-ignore"
      v-if="(fileData.previewType == '1' || fileData.previewType == '3') || showPreview"
      :preview-url="fileData.previewUrl"
      :fileId="fileData.fileId"
      :hideButton="true"
      :ext-type="fileData.extType"
      :recodeInteraction="0"
      :isDetail="true"
      :closable="fileData.previewType == '2'"
      :type="'wap'"
      @preview-close="showPreview = false"
    ></file-preview>
    <card :tenantId="tenantId" :webinarLive="'webinarLive'"></card>
    <Cta :obj="ctaObj" class="pxtovw-ignore"></Cta>
    <div class="wechat-tips" v-show="isShowTips">
      <img  src="../../assets/images/arrow.png" alt="">
      <span class="tips">请点击右上角选择在浏览器打开</span>
      <div class="tips-button" @click="close">
        返回
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "@/mixins/fileDetail.js";
import templateMixin from "@/mixins/template-detail.js";
import FilePreview from "@/components/FilePreview.vue";
import Head from "@/components/head";
import Banner from "@/components/banner";
import Back from "@/components/back";
import Card from '../../../stempcore/src/core/components/common/Card'
import Cta from '../../../stempcore/src/core/components/common/Cta'
import {  updateSearchParam } from "@/common/sbase.js";
import { URLS } from "fire-wind-water";
export default {
  name: "WapFileDetails",
  mixins: [mixin, templateMixin],
  components: { FilePreview, Head, Banner, Back, Card, Cta },
  data() {
    return {
      showPreview: false,
      platform: "wap",
      isDownload:'0',
      isShowTips:false,
      tenantId:''
    };
  },
  created() {

  },
  mounted(){
    this.isDownload = URLS.getURL("isDownload");
    if(window.$ua.isWeChat && this.isDownload == 1){
      this.isShowTips = true;
    }



  },
  watch: {
    fileData (val) {
      val;
      if(!window.$ua.isWeChat && this.isDownload == 1){
        this.onDownloadFile(val, val.downloadType);
      }

    }
  },
  methods:{
    fixPerviewHeight(){
      const header = document.getElementById('header') ? document.getElementById('header').clientHeight : 0;
      const banner = document.getElementById('banner') ? document.getElementById('banner').clientHeight : 0;
      const button = document.getElementById('item-button') ? document.getElementById('item-button').clientHeight : 0;
      const container = document.getElementById('container') ? document.getElementById('container').clientHeight : 0;
      const page = document.body.offsetHeight;
      const preview = page - header - banner - button - container;
      if(document.getElementById('preview')){
        document.getElementById('preview').style.height = preview + 'px';
      }
    },
    wapDownloadFile(fileData, downloadType) {
      if(window.$ua.isWeChat && !this.isDownload){
        window.location.href = updateSearchParam('isDownload',1,window.location.href);
        return;
      }
      if(window.$ua.isWeChat && this.isDownload) {
        this.isShowTips = true;
        return
      }
      this.onDownloadFile(fileData, downloadType);
    },
    gettenantId(val){
      this.tenantId=val
    },
    close(){
      this.isShowTips= false;
    }
  }
};
</script>

<style lang="scss" scoped>
.wap.page {
  padding-bottom: 110px;
}

.container {
  padding: 40px;
}
.header-divider {
  width: 710px;
}
.info-header {
  flex: 1;
  text-align: start;
  padding: 0 0 30px;
  .title {
    margin: 25px 0;
    font-size: 34px;
    font-weight: bold;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .stat-info {
    margin-top: 16px;
    color: rgb(153, 153, 153);
    display: flex;
    .date {
      margin-right: auto;
    }
    .right {
      margin-left: 28px;
    }
    i {
      font-size: 24px;
      padding-right: 8px;
    }
  }
  .file-action {
    margin-top: 18px;
    .action-btn {
      display: inline-block;
      font-size: 24px;
      line-height: 24px;
      text-align: center;
      color: $color-base;
      padding: 8px 10px;
      margin-right: 25px;
      border: solid 1px $color-base;
      border-radius: 8px;
      i {
        font-size: 24px;
        padding-right: 5px;
      }
    }
  }
}
.desc-info {
  margin: 24px 0;
  overflow-wrap: break-word;
}
.content-rich-text {
  margin-top: 30px;
  padding-top: 30px;
  border-top: 1px solid #f0f0f0;
}
.content-preview {
  height: 100vh;
}
.rich-text-html {
  overflow: hidden;
  img {
    max-width: 100%;
  }
}
.item-content {
  position: relative;
  color: #212121;
  .item-title {
    width: 100%;
    font-size: 32px;
    font-weight: 600;
    color: #333333;
    line-height: 46px;
    // overflow: hidden;
    word-break: break-all;
    // text-overflow: ellipsis;
  }
  .item-summary {
    font-size: 26px;
    // opacity: 0.62;
    color: #888888;
    line-height: 32px;
    margin-top: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
  .item-date {
    margin-top: 30px;
    margin-bottom: 10px;
    font-size: 25px;
    // opacity: 0.62;
    font-weight: 400;
    color: #aaaaaa;
    .icontemp {
      margin-left: 30px;
      margin-right: 7px;
      font-size: 26px;
    }
  }
}
.item-button {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
  text-align: center;
  background: #ffffff;
  box-shadow: 0px -1px 6px 1px rgba(237, 237, 237, 0.5);
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}
.button {
  display: inline-block;

  /*width: 124px;*/
  min-width: 230px;
  margin-left: 30px;
  height: 68px;
  box-sizing: border-box;
  line-height: 68px;
  text-align: center;
  border: 1px solid $blue;
  border-radius: 4px;
  color: $blue;
  font-weight: 400;
  font-size: 30px;
  background-color: #ffffff;
  cursor: pointer;
  max-width: 330px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding: 0 10px;
  &:first-of-type {
    margin-left: 0;
  }
}
</style>
